module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("blK3L"))).then(() => parcelRequire('37nVf'));